import { render, staticRenderFns } from "./app-skeleton-grid.vue?vue&type=template&id=2c955c90&"
import script from "./app-skeleton-grid.vue?vue&type=script&lang=js&"
export * from "./app-skeleton-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports